<template>
	<div class="row">
		<div class="col-md-6 mt-4">
			<SignupInfo />
		</div>
		<div class="col-md-6 mt-4">
			<SignupForm />
		</div>
	</div>
</template>
<script>
import SignupForm from '@/components/SignupForm.vue'
import SignupInfo from '@/components/SignupInfo.vue'
export default {
  name: 'SignupPage',
  components: {
    SignupForm,
    SignupInfo
  }
}

</script>
